import React, { useState } from "react";
import clsx from "clsx";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import { Collapse, makeStyles } from "@material-ui/core";
import { color, motion } from "framer-motion";
import Link from "../../components/v2/Link";
import LazyImage from "../../components/v4/LazyLoadImage/LazyImage";
import AllCountries from "../../components/v4/AllCountries/AllCountries";
import TestimonialSlider from "../../components/v3/TestimonialSlider/TestimonialSlider";
import FaqSection from "../../components/v4/FaqSection/FaqSection";
import TruestedSection from "../../components/v4/TrustedSection/TruestedSection";

import whiteCheckCircle from "../../images/v4/whatsappPage/icons/whiteCheckCircle.svg";
import greenCheckCircle from "../../images/v4/whatsappPage/icons/greenCheckCircle.svg";
import downArrow from "../../images/v4/aiPage/icons/downArrow.svg";
import bodySectionBg from "../../images/v4/country/hongKong/images/bodySectionBg.png";
import heroBg from "../../images/v4/country/hongKong/images/heroBg.png";

import hongKong from "../../images/v4/country/hongKong/icons/hongKong.svg";

import bestIcon1 from "../../images/v4/country/india/icons/bestIcon1.svg";
import bestIcon2 from "../../images/v4/country/india/icons/bestIcon2.svg";
import bestIcon3 from "../../images/v4/country/india/icons/bestIcon3.svg";
import bestIcon4 from "../../images/v4/country/india/icons/bestIcon4.svg";
import bestIcon5 from "../../images/v4/country/india/icons/bestIcon5.svg";

import smartIcon1 from "../../images/v4/country/india/icons/smartIcon1.svg";
import smartIcon2 from "../../images/v4/country/india/icons/smartIcon2.svg";
import smartIcon3 from "../../images/v4/country/india/icons/smartIcon3.svg";
import smartIcon4 from "../../images/v4/country/india/icons/smartIcon4.svg";
import smartIcon5 from "../../images/v4/country/india/icons/smartIcon5.svg";
import smartIcon6 from "../../images/v4/country/india/icons/smartIcon6.svg";
import smartIcon7 from "../../images/v4/country/india/icons/smartIcon7.svg";
import smartIcon8 from "../../images/v4/country/india/icons/smartIcon8.svg";
import smartIcon9 from "../../images/v4/country/india/icons/smartIcon9.svg";

import partnerIcon1 from "../../images/v4/aiPage/icons/partnerIcon1.png";
import partnerIcon2 from "../../images/v4/aiPage/icons/partnerIcon2.png";
import partnerIcon3 from "../../images/v4/aiPage/icons/partnerIcon3.png";
import partnerIcon5 from "../../images/v4/aiPage/icons/partnerIcon5.png";
import partnerIcon6 from "../../images/v4/aiPage/icons/partnerIcon6.png";
import partnerIcon7 from "../../images/v4/aiPage/icons/partnerIcon7.png";
import partnerIcon8 from "../../images/v4/aiPage/icons/partnerIcon8.png";

import compareItemImg1 from "../../images/v4/industry/education/images/compareItemImg1.png";
import compareItemImg2 from "../../images/v4/industry/education/images/compareItemImg2.png";
import compareItemImg3 from "../../images/v4/industry/education/images/compareItemImg3.png";
import compareItemImg4 from "../../images/v4/industry/education/images/compareItemImg4.png";
import compareItemImg5 from "../../images/v4/country/malaysia/images/compareItemImg5.png";

import countryBackground from "../../images/v4/country/hongKong/images/countryBackground.png";
import benefitImg from "../../images/v4/country/hongKong/images/benefitImg.png";

import realWorldImg1 from "../../images/v4/country/hongKong/images/realWorldImg1.png";
import realWorldImg2 from "../../images/v4/country/hongKong/images/realWorldImg2.png";
import realWorldImg3 from "../../images/v4/country/hongKong/images/realWorldImg3.png";
import realWorldImg4 from "../../images/v4/country/hongKong/images/realWorldImg4.png";
import SEO from "../../components/SEO";

const useStyles = makeStyles((theme) => ({
  heroSection: {
    background: `url(${heroBg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "top",
    padding: "100px 0 60px",
    "& .countryHighlight": {
      background: "linear-gradient(93deg, #F00 0.73%, #FF9500 100.97%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "16px",
      width: "85%",
      margin: "0 auto",
      textAlign: "center",
      "& .buttonContaienr": {
        justifyContent: "center",
      },
      "@media only screen and (max-width: 600px)": {
        width: "100%",
        marginTop: "0px",
        "& .buttonContaienr": {
          alignItems: "center",
        },
        "& .primaryButton": {
          width: "100%",
        },
        "& .countryLogo": {
          width: "30px",
        },
      },
    },
    "@media only screen and (max-width: 600px)": {
      padding: "0",
    },
  },
  listContainer: {
    display: "flex",
    marginTop: "16px",
    // flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      minWidth: "100%",
      gap: "15px",
    },
  },
  listItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    border: "1px solid #00B661",
    borderRadius: "50px",
    padding: "10px 15px",
    minWidth: "max-content",
    "@media only screen and (max-width: 600px)": {
      minWidth: "90%",
    },
    // color: "#A2BED3",
  },
  compareSection: {
    position: "relative",
    paddingTop: "200px",
    paddingBottom: "80px",
    "& $supportBox": {
      position: "absolute",
      top: "-410px",
      background: "linear-gradient(180deg, #009A99 0%, #1C297E 100%)",
    },
    "& .header": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "540px",
      "& $supportBox": {
        top: "-770px",
      },
      "& .header": {
        width: "100%",
      },
    },
  },
  compareSectionLeftItem: {
    padding: "15px 20px",
    borderLeft: "5px solid transparent",
    transition: "0.3s ease",
    "&.active": {
      borderLeft: "5px solid #02AE7F",
    },
    "& a": {
      textDecoration: "none",
      color: "#000",
    },
  },
  compareSectionContainer: {
    gap: "40px",
    display: "flex",
    marginTop: "60px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    position: "relative",
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      marginTop: "30px",
      gap: "20px",
    },
  },
  compareSectionContainerLeftSection: {
    width: "30%",
    position: "sticky",
    top: "100px",
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      position: "static",
      display: "none",
    },
  },
  compareSectionContainerRightSection: {
    width: "70%",
    "@media only screen and (max-width: 768px)": {
      width: "100%",
    },
  },
  compareItemContainer: {
    marginBottom: "60px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: "20px",
    "& .productImage": {
      width: "100%",
    },
    "&:last-child": {
      marginBottom: 0,
    },
  },
  faqsContainer: {
    marginTop: "60px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    cursor: "pointer",
    width: "100%",
    "@media only screen and (max-width: 768px)": {
      marginTop: 0,
    },
  },
  faqBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    borderBottom: "1px solid #B7B7B7",
    width: "100%",
    "&:first-child": {
      borderTop: "1px solid #B7B7B7",
      paddingTop: "15px",
    },
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 600px)": {
      "& h3": {
        textAlign: "left",
      },
    },
  },
  downArrow: {
    transition: "0.3s ease",
    "&.active": {
      transform: "rotate(180deg)",
    },
  },
  body: {
    textAlign: "left",
    margin: "10px 0 15px",
  },
  partnerSlide: {
    width: "185px !important",
    "& img": {
      width: "185px",
      filter: "brightness(0.1)",
    },
    "@media only screen and (max-width: 600px)": {
      width: "140px !important",
      marginRight: "30px !important",
      "& img": {
        width: "140px",
        filter: "brightness(0.1)",
      },
    },
  },
  partnerSlider: {
    padding: "10px 0 40px !important",
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "40px !important",
    },
  },
  stripSection: {
    backgroundColor: "#e9f4fe",
    // backgroundImage: `url(${partnerSectionBackground})`,
    backgroundPosition: "top",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    "& .centerContainer": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        textAlign: "center",
      },
    },
  },
  testimonials: {
    background: "#e9f4fe",
  },
  wpFaq: {
    padding: "40px 0",
    background: "#eaffff",
    "@media only screen and (max-width: 600px)": {
      "& section": {
        padding: "0px 0 0 !important",
      },
    },
  },
  commonPageFooterSection: {
    background: "linear-gradient(to right, #011d32 -1%, #00182b 100%)",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  growingBusiness: {
    //paddingTop: "60px",
    backgroundImage: `url(${bodySectionBg})`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    paddingBottom: "300px",
    position: "relative",
    "& .header": {
      width: "60%",
      textAlign: "left",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
    },
    "& .body": {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "stretch",
      gap: "20px",
      flexWrap: "wrap",
      marginTop: "60px",
    },
    "& $featureContainer": {
      gap: "20px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "60px 0 300px",
      "& .header": {
        width: "100%",
      },
    },
    "& $broadcastLeftContainer": {
      width: "55%",
    },
  },
  practiceCard: {
    background: "#ffffff1a",
    borderRadius: "16px",
    padding: "24px",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    gap: "16px",
    width: "32%",
    opacity: "1",
    backdropFilter: "blur(30px) brightness(1)",
    transition: "0.3s ease",
    "&:hover": {
      backdropFilter: "blur(50px) brightness(1.2)",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  countrySection: {
    padding: "60px 0",
    borderRadius: "40px 40px 0 0",
    backgroundImage: `url(${countryBackground})`,
    backgroundSize: "cover",
    "& .header": {
      width: "60%",
      textAlign: "left",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "& .cards": {
      display: "flex",
      width: "100%",
      justifyContent: "flex-start",
      gap: "20px",
      alignItems: "stretch",
      marginTop: "60px",
      "@media only screen and (max-width: 600px)": {
        flexDirection: "column",
        marginTop: "40px",
      },
    },
    "& .card": {
      padding: "32px 24px",
      borderRadius: "16px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      gap: "32px",
      backdropFilter: "blur(20px)",
      border: "1px solid #534B69 ",
      width: "48%",
      background:
        "linear-gradient(to bottom, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3))",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      padding: "0",
    },
  },
  tabsSection: {
    background: "#F1FAF9",
    paddingTop: "280px",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "& $supportBox": {
      position: "absolute",
      top: "-530px",
      "@media only screen and (max-width: 600px)": {
        top: "-800px",
        marginTop: 0,
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "550px",
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  tabsContainer: {
    width: "90%",
    minWidth: "max-content",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px",
    border: "2px solid #DBDBDB",
    borderRadius: "40px",
    background: "#fff",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "10px",
      padding: "5px",
      overflow: "auto",
      minWidth: "100%",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },
  },
  tab: {
    width: "25%",
    minWidth: "max-content",
    background: "",
    padding: "18px",
    background: "transparent",
    borderRadius: "40px",
    background: "transparent",
    transition: "0.3s ease",
    cursor: "pointer",
    "&.active": {
      color: "white",
      background:
        "linear-gradient(90deg, #FF682A 0%, #FF7056 35%, #FF682A 73%, #FF550F 100%)",
    },
    "@media only screen and (max-width: 600px)": {
      minWidth: "max-content",
      padding: "10px 15px",
    },
  },
  tabCard: {
    marginTop: "20px",
    gap: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    "@media only screen and (max-width: 600px)": {
      marginTop: "30px",
      flexDirection: "column",
    },
  },
  tabCardLeftContainer: {
    width: "50%",
    display: "flex",
    gap: "40px",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      gap: "20px",
      width: "100%",
    },
  },
  benfitListContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "30px",
    marginTop: "50px",
    "@media only screen and (max-width: 600px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  benfitListItem: {
    display: "flex",
    width: "100%",
    margin: "0 auto",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    position: "relative",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "15px",
      alignItems: "flex-start",
    },
  },
  benfitListItemContent: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "10px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  tabCardRightContainer: {
    width: "50%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  benfitIcon: {
    position: "relative",
    top: "5px",
  },
  supportBox: {
    top: "100%",
    width: "100%",
    display: "flex",
    padding: "40px",
    background: "linear-gradient(179deg, #F77F4C -19.72%, #9227E9 105.7%)",
    position: "relative",
    alignItems: "center",
    borderRadius: "20px",
    backdropFilter: "blur(30px)",
    justifyContent: "space-between",
    "& $broadcastLeftContainer": {
      width: "55%",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      width: "94%",
      padding: "15px",
      marginTop: "20px",
      gap: "20px",
    },
  },
  pointers: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "20px",
  },
  cardPointer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      alignItems: "center",
    },
  },
  broadcastLeftContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "60%",
    gap: "32px",
    textAlign: "left",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "20px",
    },
  },
  broadcastRightContainer: {
    width: "40%",
    "& img": {
      width: "100%",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "& img": {
        width: "100%",
      },
    },
  },
  broadcastImg: {
    "& img": {
      width: "100%",
      position: "relative",
      bottom: "0",
    },
  },
  adaptFeatures: {
    backgroundrepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundImage: `url(${heroBg})`,
    "& .header": {
      display: "flex",
      width: "55%",
      gap: "10px",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      textAlign: "left",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "& .container": {
      paddingBottom: "35px",
    },
  },
  adaptSlider: {
    "@media only screen and (max-width: 600px)": {
      padding: "15px 15px 40px",
    },
    "@media only screen and (min-width: 1400px)": {
      padding: "15px 8rem 60px",
    },
    "@media only screen and (min-width: 1900px)": {
      padding: "15px 23rem 60px",
    },
  },
  adaptsBox: {
    gap: "16px",
    display: "flex",
    padding: "24px",
    background: "#fff",
    alignItems: "stretch",
    borderRadius: "20px",
    flexDirection: "column",
    justifyContent: "flex-start",
    boxShadow: "0px 0px 24px #D4E0E9",
    borderRadius: "16px",
    maxWidth: "380px",
    minHeight: "220px",
    "@media only screen and (max-width: 600px)": {
      padding: "15px",
      maxWidth: "80%",
      gap: "15px",
    },
  },
  adaptBoxHeader: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "16px",
  },
}));

const HongKong = () => {
  const classes = useStyles();
  const [activeCompare, setActiveCompare] = useState("#section0");
  const [activeAccordian, setActiveAccordian] = useState(0);
  const [activeRealWorld, setActiveRealWorld] = useState(0);
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 100; // Height of navigation bar
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };
  const partners = [
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
  ];
  const faqs = [
    {
      question:
        "Which is the best CRM software in Hong Kong for small businesses?",
      answer: (
        <>
          Pepper Cloud CRM is specifically designed for SMEs in Hong Kong,
          offering affordable pricing combined with the essential features
          needed to drive growth efficiently.
        </>
      ),
    },
    {
      question: "How to get CRM for your Hong Kong growing business?",
      answer: (
        <>
          <ul>
            <li>
              Book a free demo for a personalised walkthrough focused on your
              business needs.
            </li>
            <li>
              Discuss your requirements with our Hong Kong CRM experts to find
              the ideal plan.
            </li>
            <li>
              Set up your account quickly and easily – no complex procedures or
              setup fees.
            </li>
            <li>
              Customise the CRM to perfectly match your sales workflows,
              pipelines, and automation rules.
            </li>
            <li>
              Go live and leverage AI-powered tools to scale your Hong Kong
              business faster.
            </li>
          </ul>
        </>
      ),
    },
    {
      question: "How to choose the best CRM for your Hong Kong business?",
      answer: (
        <>
          <ul>
            <li>
              Scalability: Select a CRM that can grow with your business,
              handling increasing data and users.
            </li>
            <li>
              Customisation: Ensure the CRM adapts to your unique industry needs
              and processes in Hong Kong.
            </li>
            <li>
              Integration capabilities: Verify seamless connection with
              essential tools like WhatsApp, Google Workspace, etc.
            </li>
            <li>
              Local support: Choose a provider offering knowledgeable support
              within the Hong Kong context.
            </li>
            <li>
              Affordable pricing: Look for transparent, value-driven pricing
              without hidden costs.
            </li>
          </ul>
        </>
      ),
    },
    {
      question: "Is Pepper Cloud CRM suitable for Hong Kong startups?",
      answer: (
        <>
          Absolutely. It's scalable, easy to implement, and includes automation
          features specifically designed to help startups in Hong Kong grow
          rapidly.
        </>
      ),
    },
    {
      question: "Can I integrate Pepper Cloud CRM with my current tools?",
      answer: (
        <>
          Yes, Pepper Cloud integrates seamlessly with many popular business
          tools, including email, forms, calendars, accounting software,
          messaging apps like WhatsApp, and various{" "}
          <a href="https://peppercloud.com/crm-integrations">
            third-party applications
          </a>{" "}
          used in Hong Kong.
        </>
      ),
    },
    {
      question: "How secure is Pepper Cloud CRM?",
      answer: (
        <>
          Pepper Cloud employs multi-layered security protocols and best
          practices to protect your customer data and ensure compliance with
          relevant regulations.
        </>
      ),
    },
    {
      question: "Which CRM is most used in Hong Kong?",
      answer: (
        <>
          While various global CRMs are used, Pepper Cloud CRM is quickly
          becoming a preferred choice for Hong Kong SMEs. This is due to its
          user-friendly interface, affordability, strong integrations (like
          WhatsApp), and features tailored to local business requirements.
        </>
      ),
    },
    {
      question: "Is Pepper Cloud CRM costly?",
      answer: (
        <>
          Not at all. Pepper Cloud CRM provides flexible pricing plans to suit
          every business size in Hong Kong, from startups to enterprises. You
          pay only for the features you need, ensuring a cost-effective
          investment.
        </>
      ),
    },
    {
      question: "Which CRM is best for small business?",
      answer: (
        <>
          For small businesses, the ideal CRM is cost-effective, easy to use,
          and scalable. Pepper Cloud CRM is an excellent choice for small
          businesses in Hong Kong, offering an intuitive interface, AI
          automation, and crucial integrations like WhatsApp to manage leads and
          relationships effectively.
        </>
      ),
    },
  ];

  const compareItems = [
    "Pepper Cloud CRM",
    "HubSpot CRM",
    "Salesforce",
    "Zoho CRM",
    "Microsoft Dynamics 365",
  ];
  const compareData = [
    {
      title: "Pepper Cloud CRM",
      desc: "Pepper Cloud CRM is the leading choice for Hong Kong businesses seeking a comprehensive, tailored solution. It effectively combines powerful lead management, an AI-driven suite, workflow automation, and essential integrations (including WhatsApp), making it perfectly adapted for Hong Kong's dynamic business environment.",
      img: compareItemImg1,
      alt: "",
      features: [
        {
          title: "AI-Powered Suite",
          desc: "Leverage chatbots, real-time sales assistance, and task automation to boost efficiency.",
        },
        {
          title: "Integrated Messaging",
          desc: "Engage customers seamlessly via WhatsApp and other key messaging platforms.",
        },
        {
          title: "Advanced Lead Management",
          desc: "Capture, track, and score leads effectively with built-in tools.",
        },
        {
          title: "Omnichannel Connectivity",
          desc: "Manage conversations from calls, social media, email, and messaging apps centrally.",
        },
        {
          title: "Flexible Automation",
          desc: "Customise workflows to automate routine tasks based on specific triggers or schedules.",
        },
        {
          title: "Customisable Dashboards",
          desc: "Gain actionable insights with easy-to-configure reports and performance metrics.",
        },
        {
          title: "Industry-Specific Solutions",
          desc: "Offers tailored features for key Hong Kong sectors like finance, retail, and logistics.",
        },
      ],
      cta: "Get demo",
    },
    {
      title: "HubSpot CRM",
      desc: "HubSpot CRM is a globally recognized platform ideal for aligning sales and marketing efforts. Its ease of use and scalability make it popular among Hong Kong SMEs and startups.",
      img: compareItemImg2,
      alt: "",
      features: [
        {
          title: "Intuitive Pipeline Builder",
          desc: "Customise sales processes easily with a drag-and-drop interface.",
        },
        {
          title: "Marketing Automation",
          desc: "Manage campaigns across email, social media, and other channels effectively.",
        },
        {
          title: "Free Tier Availability",
          desc: "Offers a functional free plan, suitable for small teams starting out.",
        },
        {
          title: "Large Integration Ecosystem",
          desc: "Connects readily with a wide range of third-party applications.",
        },
      ],
    },
    {
      title: "Salesforce",
      desc: "Salesforce is a powerful, enterprise-grade CRM platform suited for larger Hong Kong companies with complex operational needs and requiring extensive customisation.",
      img: compareItemImg3,
      alt: "",
      features: [
        {
          title: "Extensive Appexchange",
          desc: "Provides access to thousands of industry-specific apps and plugins.",
        },
        {
          title: "Einstein AI Capabilities",
          desc: "Offers predictive insights for smarter forecasting and decision-making.",
        },
        {
          title: "Highly Customisable Workflows",
          desc: "Build sophisticated, tailored automations for diverse business functions.",
        },
        {
          title: "Advanced Reporting and Analytics",
          desc: "Delivers deep business intelligence and forecasting tools.",
        },
      ],
    },
    {
      title: "Zoho CRM",
      desc: "Zoho CRM is an affordable yet robust CRM system popular with small to mid-sized businesses in Hong Kong, known for its mobile capabilities and modular flexibility.",
      img: compareItemImg4,
      alt: "",
      features: [
        {
          title: "Zia AI Assistant",
          desc: "Provides predictive analytics and automation features for smarter sales processes.",
        },
        {
          title: "Multichannel Communication Support",
          desc: "Connects with customers via phone, email, social media, and chat.",
        },
        {
          title: "Adaptable Modules",
          desc: "Allows businesses to tailor the CRM structure to fit their specific workflows.",
        },
        {
          title: "Gamification Features",
          desc: "Includes tools to boost team engagement and motivation.",
        },
      ],
    },
    {
      title: "Microsoft Dynamics 365",
      desc: "Microsoft Dynamics 365 is an enterprise CRM solution offering seamless integration with Microsoft Office and Teams, ideal for Hong Kong businesses already utilising the Microsoft stack.",
      img: compareItemImg5,
      alt: "",
      features: [
        {
          title: "LinkedIn Sales Navigator Integration",
          desc: "Enhances lead generation and outreach capabilities.",
        },
        {
          title: "Power BI Integration",
          desc: "Enables advanced data visualisation and sharing across teams.",
        },
        {
          title: "AI-Driven Insights",
          desc: "Provides forecasting and behaviour analysis using machine learning models.",
        },
      ],
    },
  ];

  const bestPractice = [
    {
      icon: smartIcon1,
      alt: "",
      heading: "Intelligent automation",
      desc: "Automate routine tasks, provide real-time support to your sales team, and gain actionable insights with AI chatbots and smart analytics.",
    },
    {
      icon: smartIcon2,
      alt: "",
      heading: "Effective lead handling",
      desc: "Capture, assign, and track leads from WhatsApp, web forms, social media, and more in a centralised system designed for Hong Kong businesses.",
    },
    {
      icon: smartIcon3,
      alt: "",
      heading: "Clear sales pipeline visibility",
      desc: "Visualise your entire sales journey using customisable multi-level pipelines and accurate forecasting tools, enabling faster, data-driven decisions.",
    },
    {
      icon: smartIcon4,
      alt: "",
      heading: "Automated workflow",
      desc: "Set up time-based or event-triggered automations for lead routing, follow-ups, and alerts, boosting team productivity and reducing manual errors.",
    },
    {
      icon: smartIcon5,
      alt: "",
      heading: "Integrated WhatsApp CRM",
      desc: "Engage customers directly on WhatsApp with automated messages, personalised campaigns, and efficient handling features built directly into the CRM.",
    },
    {
      icon: smartIcon6,
      alt: "",
      heading: "Multichannel communication",
      desc: "Connect with customers via email, WhatsApp, Facebook, and more. Manage all conversations in one place with Pepper Cloud CRM for a seamless experience.",
    },
    {
      icon: smartIcon7,
      alt: "",
      heading: "Task and activity management",
      desc: "Assign tasks, schedule meetings, and track follow-ups effectively, ensuring your Hong Kong sales team stays focused and organised.",
    },
    {
      icon: smartIcon8,
      alt: "",
      heading: "Featured mobile CRM App",
      desc: "Empower your field teams with our comprehensive mobile CRM app. Access data, update records, and close deals from anywhere in Hong Kong.",
    },
    {
      icon: smartIcon9,
      alt: "",
      heading: "Extensive system integration",
      desc: "Seamlessly integrate Pepper Cloud CRM with Google Workspace, Microsoft 365, Xero, QuickBooks, and more for a unified, efficient business ecosystem.",
    },
  ];
  const tabContentData = [
    {
      tabContent: [
        {
          heading: "AI-powered lead capture",
          content: "Automate and nurture leads with AI workflows.",
          alt: "E-commerce CRM",
        },
        {
          heading: "AI-driven support",
          content: "Offer product suggestions and instant help via chatbots.",
          alt: "E-commerce CRM",
        },
        {
          heading: "Omnichannel engagement",
          content: "Manage customer comms from one inbox.",
          alt: "E-commerce CRM",
        },
        {
          heading: "AI insights",
          content: "Use analytics to track conversions and buying behavior.",
          alt: "E-commerce CRM",
        },
      ],
      img: realWorldImg1,
      alt: "E-commerce CRM for Hong Kong",
      subtitle:
        "Boost online sales and customer loyalty with an AI-powered CRM optimising engagement and conversions.",
    },
    {
      tabContent: [
        {
          heading: "Client onboarding:",
          content: "Automate data collection for faster cycles.",
          alt: "Finance and Banking CRM",
        },
        {
          heading: "Automated workflows",
          content: "Ensure compliance with automated checks.",
          alt: "Finance and Banking CRM",
        },
        {
          heading: "Personalised support",
          content: "Tailored financial advice based on profiles.",
          alt: "Finance and Banking CRM",
        },
        {
          heading: "Secure communication",
          content: "Manage sensitive interactions securely.",
          alt: "Finance and Banking CRM",
        },
      ],
      img: realWorldImg2,
      alt: "Finance and Banking CRM for Hong Kong",
      subtitle:
        "Enhance client management, streamline processes, and ensure compliance in Hong Kong's demanding financial sector.",
    },
    {
      tabContent: [
        {
          heading: "AI scheduling",
          content: "Automate bookings, confirmations, and reminders.",
          alt: "Healthcare CRM",
        },
        {
          heading: "AI support",
          content: "Instant 24/7 answers to patient queries via chatbots.",
          alt: "Healthcare CRM",
        },
        {
          heading: "Patient communication",
          content: "Securely manage all patient interactions in one place.",
          alt: "Healthcare CRM",
        },
        {
          heading: "Smart insights",
          content: "Track interactions for reporting and compliance.",
          alt: "Healthcare CRM",
        },
      ],
      img: realWorldImg3,
      alt: "Healthcare CRM for Hong Kong",
      subtitle:
        "Improve patient experience and operational flow with an AI-enhanced CRM tailored for healthcare.",
    },
    {
      tabContent: [
        {
          heading: "AI student support",
          content:
            "Instant responses to student inquiries, boosting satisfaction.",
          alt: "Education CRM",
        },
        {
          heading: "Automated workflows",
          content: "AI automates scheduling, reminders, and tracking.",
          alt: "Education CRM",
        },
        {
          heading: "Omnichannel comms",
          content: "Engage students across preferred channels from CRM.",
          alt: "Education CRM",
        },
        {
          heading: "AI insights",
          content:
            " Monitor engagement and performance for data-driven decisions.",
          alt: "Education CRM",
        },
      ],
      img: realWorldImg4,
      alt: "Education CRM for Hong Kong",
      subtitle:
        "Improve student engagement and administrative efficiency with an AI-powered CRM solution.",
    },
  ];
  const cards = [
    {
      heading: "What is CRM software in Hong Kong?",
      content:
        "CRM software in Hong Kong provides businesses with the tools to effectively manage customer relationships, automate key processes, and accelerate growth. It brings together communication, lead nurturing, and sales management into one powerful platform.",
    },
    {
      heading: "Why Hong Kong businesses need a CRM",
      content:
        "To thrive in Hong Kong's fast-paced and competitive business environment, a CRM system is crucial. It helps companies build stronger client relationships, improve internal collaboration, and streamline operations for greater efficiency and scalability. A CRM provides the foundation to grow faster and serve customers better.",
    },
  ];
  const adaptList = [
    {
      pointer: "All-in-one CRM",
      desc: "Pepper Cloud combines lead management and sales automation into one unified platform—no need for multiple tools.",
      img: bestIcon1,
    },
    {
      pointer: "All-size business",
      desc: "Whether you're a startup, SME or enterprise, our CRM is tailored to suit your business stage and industry.",
      img: bestIcon2,
    },
    {
      pointer: "Affordable pricing",
      desc: "Transparent and cost-effective plans with zero setup charges—built to support Malaysian SMEs and startups.",
      img: bestIcon3,
    },
    {
      pointer: "24/7 local support",
      desc: "Get round-the-clock help from our team who understands the Malaysian market and speaks your language.",
      img: bestIcon4,
    },
    {
      pointer: "Advanced customisation",
      desc: "Tailor the CRM with flexible workflows, custom fields, and pipeline stages to match your unique sales process.",
      img: bestIcon5,
    },
  ];
  const pointers = [
    "Achieve unparalleled insight into your sales pipeline for faster deal closures and smarter strategies.",
    "Consolidate customer information onto one platform, enhancing team collaboration and customer satisfaction.",
    "Increase operational efficiency by automating repetitive tasks like follow-ups and data entry.",
    "Cultivate stronger, more profitable customer relationships through personalised and timely engagement.",
  ];
  return (
    <main>
      <SEO
        title={"Best Ai-powered CRM Software in Hong Kong | Pepper Cloud"}
        pathname={
          "https://peppercloud.com/countrybest-crm-software-in-hong-kong"
        }
        keywords="best crm software in Hong Kong, crm software Hong Kong, crm system in Hong Kong, crm system Hong Kong, best crm Hong Kong"
        description={
          "Drive growth for your Hong Kong business with the best CRM software. Pepper Cloud helps you manage leads, automate tasks, and engage customers seamlessly."
        }
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Pepper Cloud",
            legalName: "Pepper Cloud PTE LTD",
            url: "https://peppercloud.com/",
            logo: "https://peppercloud.com/icons/logo.png",
            foundingDate: "2017",
            address: [
              {
                "@type": "PostalAddress",
                streetAddress: "#04-01/02",
                addressLocality: "Blk 79 Ayer Rajah Crescent",
                addressRegion: "SG",
                postalCode: "139955",
                addressCountry: "Singapore",
              },
              {
                "@type": "PostalAddress",
                streetAddress:
                  "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                addressLocality: "Bengaluru",
                addressRegion: "KA",
                postalCode: "560095",
                addressCountry: "India",
              },
            ],
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              telephone: "+6566562616",
              email: ["sales@peppercloud.com", "support@peppercloud.com"],
            },
            sameAs: [
              "https://twitter.com/peppercloudpte",
              "https://www.linkedin.com/company/peppercloud/",
              "https://www.facebook.com/PepperCloudPteLtd",
              "https://www.instagram.com/pepper.cloud/",
            ],
          },
          {
            "@context": "https://schema.org/",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "Which is the best CRM software in Hong Kong for small businesses?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud CRM is specifically designed for SMEs in Hong Kong, offering affordable pricing combined with the essential features needed to drive growth efficiently.",
                },
              },
              {
                "@type": "Question",
                name: "How to get CRM for your Hong Kong growing business?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Starting with the best CRM software in Hong Kong is simple. Pepper Cloud CRM helps startups and scaling enterprises manage leads, sales, and customer relationships effectively.",
                },
              },
              {
                "@type": "Question",
                name: "How to choose the best CRM for your Hong Kong business",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "a. Scalability: Select a CRM that can grow with your business, handling increasing data and users. b. Customisation: Ensure the CRM adapts to your unique industry needs and processes in Hong Kong. c. Integration capabilities: Verify seamless connection with essential tools like WhatsApp, Google Workspace, etc. d. Local support: Choose a provider offering knowledgeable support within the Hong Kong context. e. Affordable pricing: Look for transparent, value-driven pricing without hidden costs.",
                },
              },
              {
                "@type": "Question",
                name: "Is Pepper Cloud CRM suitable for Hong Kong startups?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Absolutely. It's scalable, easy to implement, and includes automation features specifically designed to help startups in Hong Kong grow rapidly.",
                },
              },
              {
                "@type": "Question",
                name: "Can I integrate Pepper Cloud CRM with my current tools?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, Pepper Cloud integrates seamlessly with many popular business tools, including email, forms, calendars, accounting software, messaging apps like WhatsApp, and various third-party applications used in Hong Kong.",
                },
              },
              {
                "@type": "Question",
                name: "How secure is Pepper Cloud CRM?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud employs multi-layered security protocols and best practices to protect your customer data and ensure compliance with relevant regulations.",
                },
              },
              {
                "@type": "Question",
                name: "Which CRM is most used in Hong Kong?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "While various global CRMs are used, Pepper Cloud CRM is quickly becoming a preferred choice for Hong Kong SMEs. This is due to its user-friendly interface, affordability, strong integrations (like WhatsApp), and features tailored to local business requirements.",
                },
              },
              {
                "@type": "Question",
                name: "Is Pepper Cloud CRM costly?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Not at all. Pepper Cloud CRM provides flexible pricing plans to suit every business size in Hong Kong, from startups to enterprises. You pay only for the features you need, ensuring a cost-effective investment.",
                },
              },
              {
                "@type": "Question",
                name: "Which CRM is best for small business?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "For small businesses, the ideal CRM is cost-effective, easy to use, and scalable. Pepper Cloud CRM is an excellent choice for small businesses in Hong Kong, offering an intuitive interface, AI automation, and crucial integrations like WhatsApp to manage leads and relationships effectively.",
                },
              },
            ],
          },
        ]}
      />
      <section className={classes.heroSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h1
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-72 color-black1"
            >
              Grow faster with the best CRM software in{" "}
              <img className="countryLogo" src={hongKong} alt="hong kong" />{" "}
              <span className="countryHighlight">Hong kong</span>
            </motion.h1>
            <motion.p
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-inter-regular font-18 color-black2 mt10"
              //   style={{ color: "#A2BED3" }}
            >
              Pepper Cloud CRM, the premier CRM software in Hong Kong, enables
              businesses to optimise sales, automate essential workflows, and
              deliver outstanding customer experiences consistently.
            </motion.p>
            <div className={classes.listContainer}>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  AI-driven workflow automation
                </p>
              </div>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  Integrated WhatsApp and messaging features
                </p>
              </div>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  A complete view of every customer interaction
                </p>
              </div>
            </div>
            <div className="buttonContaienr mt40">
              <Link
                to="/contact/"
                className="primaryButton font-20 font-wix-medium font-white"
              >
                Book a free demo
              </Link>
            </div>
          </div>
        </div>
      </section>
      <section className={classes.countrySection}>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 font-white"
            >
              A quick guide about best CRM software in Hong Kong
            </motion.h2>
          </div>
          <div className="cards">
            {cards.map((card) => (
              <div className="card">
                <p className="font-24 font-wix-semibold font-white">
                  {card.heading}
                </p>
                <p className="font-wix-regular font-18 font-white">
                  {card.content}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className={classes.adaptFeatures}>
        <div className="container">
          <div className="header">
            <motion.h2
              className="font-wix-medium font-56 color-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Why Pepper Cloud is the best CRM software system in Hong Kong
            </motion.h2>
          </div>
        </div>
        <Swiper
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              slidesPerView: "auto",
              freeMode: true,
              // grabCursor: false,
              spaceBetween: 15,
              // autoplay: false,
              // modules: [],
            },
            // For larger screens (desktop)
            // 768: {
            //   slidesPerView: "auto",
            //   slidesPerGroup: 3,
            //   spaceBetween: 30,
            //   grabCursor: true,
            // },
          }}
          className={classes.adaptSlider}
          slidesPerView={3.3}
          // centeredSlides={true}
          spaceBetween={30}
          grabCursor={true}
          loop={true}
          speed={5000}
          modules={[Autoplay]}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
        >
          {adaptList.map((point, index) => (
            <SwiperSlide className={classes.adaptsBox}>
              <div className={classes.adaptBoxHeader}>
                <img
                  alt={point.pointer}
                  className={classes.adaptBoxImg}
                  src={point.img}
                />
                <p className="font-24 font-wix-semibold ">{point.pointer}</p>
              </div>
              <div className={classes.adaptDescription}>
                <p className="font-wix-regular font-18  ">{point.desc}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
      <section className={classes.growingBusiness}>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-white"
            >
              Everything you need to sell smarter, faster, and better in Hong
              Kong
            </motion.h2>
          </div>
          <div className="body">
            {bestPractice.map((practice) => (
              <div className={classes.practiceCard}>
                <img src={practice.icon} alt={practice.heading} />
                <p className="font-wix-semibold font-24 font-white">
                  {practice.heading}
                </p>
                <p
                  className="font-wix-medium font-16"
                  style={{ color: "#E9F4FE" }}
                >
                  {practice.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className={classes.absoulteCard}>
          {/* <TruestedSection background={true} /> */}
        </div>
      </section>
      <section className={classes.tabsSection}>
        <div className="container">
          <motion.div
            initial={{ opacity: 1, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className={classes.supportBox}
            // style={{ background: point.background }}
          >
            <div className={classes.broadcastLeftContainer}>
              <p className="font-40 font-wix-regular font-white">
                Benefits of using a CRM tool for your Hong Kong growing business
              </p>
              <div className={classes.pointers}>
                {pointers.map((pointer) => (
                  <div className={classes.cardPointer}>
                    <LazyImage
                      source={whiteCheckCircle}
                      className={classes.pointerImg}
                      alt={"pointer"}
                    />
                    <p className="font-inter-regular font-18 font-white">
                      {pointer}
                    </p>
                  </div>
                ))}
              </div>
            </div>
            <div className={classes.broadcastRightContainer}>
              <LazyImage
                source={benefitImg}
                alt={
                  "Benefits of using a CRM tool for your Hong Kong growing business"
                }
                className={classes.broadcastImg}
              />
            </div>
          </motion.div>
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 color-black1"
            >
              Real-world CRM applications across Hong Kong industries
            </motion.h2>
            <div className={classes.tabsContainer}>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 0 && "active"
                )}
                onClick={() => setActiveRealWorld(0)}
              >
                E-commerce
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 1 && "active"
                )}
                onClick={() => setActiveRealWorld(1)}
              >
                Finance and banking
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 2 && "active"
                )}
                onClick={() => setActiveRealWorld(2)}
              >
                Healthcare providers
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 3 && "active"
                )}
                onClick={() => setActiveRealWorld(3)}
              >
                Education sector
              </div>
            </div>
          </div>
          <div className={classes.tabCard}>
            <div className={classes.tabCardLeftContainer}>
              {tabContentData.map(
                (listItem, index) =>
                  index === activeRealWorld && (
                    <div>
                      <motion.p
                        initial={{ opacity: 0, x: -20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.3 }}
                        className="font-wix-regular font-18 color-black2"
                      >
                        {listItem.subtitle}
                      </motion.p>
                      <div className={classes.benfitListContainer}>
                        {listItem.tabContent.map((item) => (
                          <motion.div
                            initial={{ opacity: 0, x: -20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.3 }}
                            className={classes.benfitListItem}
                          >
                            <LazyImage
                              source={greenCheckCircle}
                              className={classes.benfitIcon}
                              alt={item.alt}
                            />
                            <div className={classes.benfitListItemContent}>
                              <p className="font-wix-semibold font-20 color-black1">
                                {item.heading}
                              </p>
                              <p className="font-wix-regular font-16 color-black2">
                                {item.content}
                              </p>
                            </div>
                          </motion.div>
                        ))}
                      </div>
                    </div>
                  )
              )}
            </div>
            <div className={classes.tabCardRightContainer}>
              {tabContentData.map(
                (listItem, index) =>
                  index === activeRealWorld && (
                    <motion.div
                      initial={{ opacity: 1, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.3 }}
                      // className={classes.aiSectionRight}
                    >
                      <LazyImage
                        source={listItem.img}
                        alt={listItem.alt}
                        width={"100%"}
                      />
                    </motion.div>
                  )
              )}
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-black1"
            >
              5 best CRM software in Hong Kong
            </motion.h2>
          </div>
          <div className={classes.compareSectionContainer}>
            <div className={classes.compareSectionContainerLeftSection}>
              {compareItems.map((item, index) => (
                <div
                  className={clsx(
                    classes.compareSectionLeftItem,
                    activeCompare === `#section${index}` && "active"
                  )}
                  onClick={() => {
                    scrollToSection(`#section${index}`);
                    setActiveCompare(`#section${index}`);
                  }}
                >
                  <a
                    href={`#section${index}`}
                    className={clsx(
                      "font-22 font-wix-medium font-black1",
                      activeCompare === `#section${index}` && "font-wix-bold"
                    )}
                  >
                    {item}
                  </a>
                </div>
              ))}
            </div>
            <div className={classes.compareSectionContainerRightSection}>
              {compareData.map((data, outerIndex) => (
                <div
                  className={classes.compareItemContainer}
                  id={`#section${outerIndex}`}
                >
                  <h3
                    initial={{ opacity: 1, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    className="font-40 font-wix-semibold font-black1"
                  >
                    {data.title}
                  </h3>
                  <p
                    initial={{ opacity: 1, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    className="font-inter-regular font-18 font-black1"
                  >
                    {data.desc}
                  </p>
                  <img src={data.img} className="productImage" alt={data.alt} />
                  <div className={classes.faqsContainer}>
                    {data.features.map((faq, innerIndex) => (
                      <motion.div
                        whileInView={{ opacity: [0, 1], y: [50, 0] }}
                        transition={{ duration: 1, delay: innerIndex * 0.01 }}
                        className={classes.faqBox}
                        onClick={() =>
                          setActiveAccordian(
                            `${outerIndex}-${innerIndex}` === activeAccordian
                              ? -1
                              : `${outerIndex}-${innerIndex}`
                          )
                        }
                      >
                        <div className={classes.header}>
                          <h3 className="font-20 font-wix-semibold">
                            {faq.title}
                          </h3>
                          <img
                            src={downArrow}
                            alt="Arrow"
                            className={clsx(
                              classes.downArrow,
                              `${outerIndex}-${innerIndex}` ===
                                activeAccordian && "active"
                            )}
                          />
                        </div>
                        <Collapse
                          className={classes.body}
                          in={activeAccordian === `${outerIndex}-${innerIndex}`}
                        >
                          <p className="font-18 font-inter-regular color-black2">
                            {faq.desc}
                          </p>
                        </Collapse>
                      </motion.div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <TruestedSection />
      <section className={classes.stripSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h3
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-24 font-black1"
            >
              Best CRM with WhatsApp integration - Trusted by SMEs globally
            </motion.h3>
          </div>
        </div>
        <Swiper
          className={classes.partnerSlider}
          slidesPerView="auto"
          spaceBetween={60}
          loop={true}
          speed={3000}
          modules={[Autoplay]}
          allowTouchMove={false}
          autoplay={{
            delay: 100,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          }}
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              freeMode: true,
              grabCursor: false,
              allowTouchMove: true,
              spaceBetween: 20,
            },
            // For larger screens (desktop)
            768: {
              freeMode: false,
              autoplay: {
                delay: 100,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              },
              speed: 3000,
              loop: true,
              allowTouchMove: true,
            },
          }}
        >
          {partners.map((partner) => (
            <SwiperSlide className={classes.partnerSlide}>
              <img src={partner.icon} alt={partner.alt} />
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
      <div className={classes.testimonials}>
        <TestimonialSlider
          noButton={true}
          heading={"Real stories. Real results."}
          desc={
            "Discover how businesses are transforming customer engagement with Pepper Cloud."
          }
        />
      </div>
      <AllCountries />
      <div className={classes.wpFaq}>
        <FaqSection
          backgroundColor={"#eaffff"}
          heading={"FAQs - Best CRM software in Hong Kong"}
          faqs={faqs}
        />
      </div>
      <section className={classes.commonPageFooterSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-white"
            >
              Everything you need to sell smarter, faster, and better in Hong
              Kong
            </motion.h2>
            <Link
              className="primaryButton font-20 font-wix-medium font-white"
              to="/contact/"
            >
              Book a free demo
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default HongKong;
